export const filterKeyMap = {
  basic_issue: {
    date_filter: 'date_filter',
    tasks: 'to',
    priority: 'form_values.9688.choice_values[0]',
    project: 'project',
    reported_by: 'created_by',
    status: 'status',
    type: 'form_values.c9f6.choice_values[0]',
  },
  basic_task: {
    assigned_to: 'assigned_to',
    date_filter: 'date_filter',
    due_date: 'form_values.0ed3',
    priority: 'form_values.caaa.choice_values[0]',
    project: 'project',
    status: 'status',
    type: 'form_values.e331.choice_values[0]',
  },
};

export const utcDateTimeFields = [
  'due_date',
];

export const fieldNameMap = {
  assigned_to: 'Assigned To',
  reported_by: 'Reported By',
  date_filter: 'Date Filter',
  due_date: 'Due Date',
  to: 'Tasks',
  status: 'Status',
  priority: 'Priority',
  project: 'Project',
  title: 'Title',
  type: 'Type',
};

export const columnMap = {
  to: 'tasks',
  status: 'status',
  project: 'project',
  created_by: 'reported_by',
  assigned_to: 'assigned_to',
  record_sequence: 'id',
  'form_values.4ae3': 'title',
  'form_values.0ed3': 'due_date',
  'form_values.9688.choice_values[0]': 'priority', // issues
  'form_values.caaa.choice_values[0]': 'priority', // tasks
  'form_values.c9f6.choice_values[0]': 'type', // issues
  'form_values.e331.choice_values[0]': 'type', // tasks
};

export const sqlMap = (
  category: string,
  formID: string,
  type: string,
  search = '',
): string | undefined => {
  const systemSetType = type === 'basic_issue' ? 'issue_type' : 'task_type';
  const map = {
    assigned_to: `
      SELECT distinct(m.name) AS value, m.name AS label
      FROM "${formID}" t
      INNER JOIN "memberships" m
      ON t._assigned_to_id = m.user_id
      WHERE m.name ILIKE '%${search}%'
      ORDER BY label ASC LIMIT 200
    `,
    created_by: `
      SELECT distinct(m.name) AS value, m.name AS label
      FROM "${formID}" t
      INNER JOIN "memberships" m
      ON t._created_by_id = m.user_id
      WHERE m.name ILIKE '%${search}%'
      ORDER BY label ASC LIMIT 200
    `,
    project: `
      SELECT distinct(p.name) AS value, p.name AS label
      FROM "${formID}" t
      INNER JOIN "projects" p
      ON t._project_id = p.project_id
      WHERE t._project_id IS NOT null AND p.name ILIKE '%${search}%'
      ORDER BY label ASC LIMIT 200
    `,
    type: `
      SELECT distinct(${systemSetType}) AS value, ${systemSetType} AS label
      FROM "${formID}"
      WHERE ${systemSetType} IS NOT null AND ${systemSetType}::text ILIKE '%${search}%'
      ORDER BY label ASC LIMIT 200
    `,
  };

  return map[category];
};

export const systemTypeMap = {
  basic_task: {
    label: 'Task Types',
    value: 'caaa', // priority field values
  },
  basic_issue: {
    label: 'Issue Types',
    value: '9688',
  },
};
